export const DISCARD_CHANGES_EVENT_NAME = 'discard-changes';
export const RICH_FORMATTING_APPLIED = 'rich_formatting_applied';
